import { render, staticRenderFns } from "./GenerateForm.vue?vue&type=template&id=5a52383a&scoped=true"
import script from "./GenerateForm.vue?vue&type=script&lang=js"
export * from "./GenerateForm.vue?vue&type=script&lang=js"
import style0 from "./GenerateForm.vue?vue&type=style&index=0&id=5a52383a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a52383a",
  null
  
)

export default component.exports